import { clsx } from 'clsx';
import React from 'react';
import styles from './SubNav.module.css.js';
import { defaultSxProp } from '../utils/defaultSxProp.js';
import Box from '../Box/Box.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SubNav = /*#__PURE__*/React.forwardRef(function SubNav({
  actions,
  className,
  children,
  label,
  sx: sxProp = defaultSxProp,
  ...rest
}, forwardRef) {
  if (sxProp !== defaultSxProp) {
    return /*#__PURE__*/React.createElement(Box, _extends({
      as: "nav",
      ref: forwardRef,
      sx: sxProp,
      className: clsx(className, 'SubNav', styles.SubNav),
      "aria-label": label
    }, rest), /*#__PURE__*/React.createElement("div", {
      className: clsx('SubNav-body', styles.Body)
    }, children), actions && /*#__PURE__*/React.createElement("div", {
      className: clsx('SubNav-actions', styles.Actions)
    }, actions));
  }
  return /*#__PURE__*/React.createElement("nav", _extends({
    ref: forwardRef,
    className: clsx(className, 'SubNav', styles.SubNav),
    "aria-label": label
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: clsx('SubNav-body', styles.Body)
  }, children), actions && /*#__PURE__*/React.createElement("div", {
    className: clsx('SubNav-actions', styles.Actions)
  }, actions));
});
SubNav.displayName = 'SubNav';

// SubNav.Links

const SubNavLinks = /*#__PURE__*/React.forwardRef(({
  children,
  className,
  sx: sxProp = defaultSxProp,
  ...rest
}, forwardRef) => {
  if (sxProp !== defaultSxProp) {
    return /*#__PURE__*/React.createElement(Box, _extends({
      as: "div",
      ref: forwardRef,
      sx: sxProp,
      className: clsx(className, styles.Links)
    }, rest), children);
  }
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: forwardRef,
    className: clsx(className, styles.Links)
  }, rest), children);
});
SubNavLinks.displayName = 'SubNav.Links';

// SubNav.Link

const SubNavLink = /*#__PURE__*/React.forwardRef(({
  children,
  className,
  sx: sxProp = defaultSxProp,
  ...rest
}, forwardRef) => {
  if (sxProp !== defaultSxProp) {
    return /*#__PURE__*/React.createElement(Box, _extends({
      as: "a",
      ref: forwardRef,
      sx: sxProp,
      className: clsx(className, styles.Link),
      "data-selected": rest.selected,
      "aria-current": rest.selected
    }, rest), children);
  }
  return /*#__PURE__*/React.createElement("a", _extends({
    ref: forwardRef,
    className: clsx(className, styles.Link),
    "data-selected": rest.selected,
    "aria-current": rest.selected
  }, rest), children);
});
SubNavLink.displayName = 'SubNav.Link';
var SubNav$1 = Object.assign(SubNav, {
  Link: SubNavLink,
  Links: SubNavLinks
});

export { SubNav$1 as default };
